export default __webpack_public_path__ + "static/media/Saksham.f139c4d2.jpeg";